import { Box, Flex } from '@sequencehq/core-components'
import { PropsWithChildren } from 'react'
import { motion } from 'framer-motion'
import { useAtomValue } from 'jotai'
import { previewConfigAtom } from '../preview.atoms'

export const PreviewContainer = ({ children }: PropsWithChildren) => {
  const { transitionDirection } = useAtomValue(previewConfigAtom)

  return (
    <motion.div
      style={{
        minWidth: '100%',
        width: 'fit-content',
        position: 'absolute'
      }}
      initial={{
        left: transitionDirection === 'LEFT_TO_RIGHT' ? '100%' : '-100%'
      }}
      animate={{ left: '0%' }}
      exit={{
        left: transitionDirection === 'LEFT_TO_RIGHT' ? '-100%' : '100%'
      }}
    >
      <Flex margin={{ base: '0 24px', '2xl': '0 32px' }} flexDir="column">
        <Box
          width="fit-content"
          height="fit-content"
          marginLeft="auto"
          marginRight="auto"
          position="relative"
        >
          {children}
        </Box>
        <Box boxSize={{ base: '24px', '2xl': '32px' }} flexShrink="0" />
      </Flex>
    </motion.div>
  )
}
